import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../../components/Logo";

export const LegalSection = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="text-lg md:text-lg font-bold text-slate-900 mb-3">{title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-3">{children}</div>
  </section>
);

export const LegalLayout = ({ title, updated, testId, children }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-[#F7F9FC]" data-testid={testId}>
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link"><Logo size="md" /></Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">{title}</h1>
        <p className="text-sm text-slate-500 mt-3 mb-12">Last updated: {updated}</p>
        <div className="bg-white border border-slate-200 rounded-3xl p-7 sm:p-10 shadow-[0_20px_50px_-15px_rgba(15,23,42,0.08)]">
          {children}
        </div>
      </main>

      <footer className="max-w-3xl mx-auto px-5 sm:px-8 pb-12 text-xs text-slate-500 flex flex-wrap items-center gap-x-6 gap-y-2">
        <span>© 2025 Newground AI. All rights reserved.</span>
        <Link to="/privacy" className="hover:text-slate-900 transition-colors" data-testid="legal-footer-privacy">Privacy Policy</Link>
        <Link to="/terms" className="hover:text-slate-900 transition-colors" data-testid="legal-footer-terms">Terms of Service</Link>
      </footer>
    </div>
  );
};
